import { defineComponent as _defineComponent } from 'vue'
import { useDeleteReportingRequestMutation } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteReportingRequest',
  props: {
  value: {
    type: Boolean,
    required: true,
  },
  requestId: {
    type: String,
    default: null,
  },
},
  emits: ["input", "deleted"],
  setup(__props, { emit }: { emit: ({
  (e: 'input', value: boolean): void
  (e: 'deleted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const { mutate: deleteReportingRequest, loading } =
  useDeleteReportingRequestMutation()

const close = () => {
  emit('input', false)
}

const confirmDelete = async () => {
  if (!props.requestId) {
    return
  }
  await deleteReportingRequest({ id: props.requestId })
  emit('deleted')
  close()
}

return { __sfc: true,props, emit, deleteReportingRequest, loading, close, confirmDelete }
}

})